import React, {FunctionComponent, useState} from "react"
import {IconContext} from "react-icons"
import {IoChevronDown, IoChevronUp} from "react-icons/io5"
import {DroneComponentAccordion} from "@murphy-frontend/common/api/DroneEvents/types"

interface AccordionBlockProps {
	accordionComponent: DroneComponentAccordion
}

const AccordionBlock: FunctionComponent<AccordionBlockProps> = ({accordionComponent}) => {
	const [showDropDown, setShowDropDown] = useState(false)

	const onPressHandler = () => {
		setShowDropDown(!showDropDown)
	}

	return (
		<div onClick={onPressHandler} className='accordion-button-container'>
			<div className='event-accordion-wrapper'>
				<div className='event-block-title'>{accordionComponent.Content}</div>
				{showDropDown ? (
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronUp />
					</IconContext.Provider>
				) : (
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronDown />
					</IconContext.Provider>
				)}
			</div>
			{showDropDown && <div className='accordion-button-title'>{accordionComponent.Title}</div>}
		</div>
	)
}

export default AccordionBlock
